import { keyframes } from 'tss-react';

const mixins = {
  loadingAnimation: (duration = 1) => ({
    loading: {
      backgroundSize: '33% 100%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '-50% top',
      backgroundImage:
        'linear-gradient(90deg, transparent 0%, rgba(100, 100, 100, 0.2) 50%, transparent 100%)',
      animation: `${keyframes({
        '0%': {
          backgroundPositionX: '-50%',
        },
        '100%': {
          backgroundPositionX: '150%',
        },
      })} ${duration}s 0s ease-in-out infinite`,
    },
  }),

  lineClamp: (lines: number, lineHeight: string | number = '1.5em') =>
    ({
      overflow: 'hidden',
      // use this fallback when css line-clamp isn't supported
      maxHeight: `calc(${lines} * ${lineHeight})`,
      wordBreak: 'break-word',
      // in case the following weird line clamping method work, use that
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: lines,
    }) as const,

  innerBorder: <T>(properties: T, { offset = 0 } = {}) =>
    ({
      '&::before': {
        content: '""',
        pointerEvents: 'none',
        display: 'block',
        position: 'absolute',
        top: offset,
        left: offset,
        right: offset,
        bottom: offset,
        borderStyle: 'solid',
        zIndex: 1,
        ...properties,
      },
    }) as const,

  separatorCharacter: <T>(properties?: T, character = '•') =>
    ({
      '&:not(:last-child)::after': {
        content: `" ${character} "`,
        display: 'inline-block',
        ...properties,
      },
    }) as const,
};

export type MixinTypes = typeof mixins;

export default mixins;
